/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { Component } from 'react';
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID} from '../../configs/const';
import { DOMAINDISPLAY } from '../../configs/apkFileName';
let oid = OPERATOR_ID.toLowerCase()


export default class PrivacyPolicy extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    
    render() {
        return (
            <>
           <section className='sportbook-livecasino'>                
                <div className="subpage-head1">
                    <div className="subpage-head1__image">
                        <img alt="Offers Banner" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/offers-banner.jpg"} />
                    </div> 
                    <div className="subpage-head1__content">
                        <h1 className="subpage-head1__title">Responsible Gaming</h1>
                    </div>
                </div>
            </section>
                <div className="container mt-5">
                    <div className="row">
                       <div className='col-12'>
                            {/* <p className='section-head__title text-center text-uppercase termsbox'>Privacy Policy</p> */}
                        </div>
                       
                        <div className='col-12 loginrulesbox'>
                        <p className='loginrulestitle'>We Care!<br></br>
                        {DOMAINDISPLAY.name} is committed to doing everything possible to give its Customers an enjoyable gaming
experience, whilst recognising that gambling can cause problems for a minority of individuals. To
ensure that you continue to enjoy safe and manageable play we fully support Responsible
Gaming and have numerous measures in place to offer checks.
</p>

<p className='loginrulestitle font-bold'>Protection of minors</p>
<p className='loginrulestitle'>We don’t allow anyone under the age of 18 to open an account and play at {DOMAINDISPLAY.name}!. To ensure
this, we reserve the right to verify your identity and possibly lock your account until your age has
been confirmed.</p>
<p className='loginrulestitle font-bold'>Gambling Self-Assessment and Help Organisations</p>
<p className='loginrulestitle'>For assistance in identifying whether to modify or seek help for your gambling behaviour, there
are a few common warning signs that you should be aware of:</p>
                        <ul className="rulesul">
                            <li>Do you ever play for more than you intend to?</li>
                            <li>Does your gambling impact your work or social life?s</li>
                            <li>Have you tried to cut down or stop without success?</li>
                            <li>Have you ever lied or hidden signs of your gambling to family or friends?</li>
                            <li>Do you think a big win is the answer to your problems?</li>
                        </ul>
                        <p className='loginrulestitle '>If you want help determining the impact gambling has on your everyday life, you can take a
self-assessment test such as this one <a href="https://gamcare.gamtest.se"></a>(https://gamcare.gamtest.se/)
</p>
<p className='loginrulestitle '>If you or someone you know has a gambling problem we advise you consider assistance from the
below recognised organisation:</p>
<p className='loginrulestitle '>
    Gamblers Anonymous<br></br>
    Website: <a href="http://www.gamblersanonymous.org" className='font-bold'>http://www.gamblersanonymous.org</a><br></br>
    Gambling Therapy<br></br>
    Website: <a href="https://www.gamblingtherapy.org" className='font-bold'>https://www.gamblingtherapy.org</a><br></br>
</p>



                        <p className='loginrulestitle font-bold'>Identity Checks</p>
                        <p className='loginrulestitle'>We take stringent steps to ensure that only people of legal age participate and enter {DOMAINDISPLAY.name}.
Such checks include requesting the Customer to submit a copy of a photographic identification
document (such as a driver's licence, a passport or a government issued identity card), in order to
verify both age and identity.
</p>
                        <p className='loginrulestitle'>The legal age for gaming online varies from country to country and so we advise that you check
the rules of your jurisdiction before you play.
</p>
                        
                        <p className='loginrulestitle'>Any personal details we request from you are purely to verify your identity – this is a legal
requirement for both your own and our protection. If you have any questions about our identity
checks, please do not hesitate to contact <span className='font-bold'>Customer Service</span> at any time.</p> 
<p className='loginrulestitle font-bold'>Staying in Control</p> 
<p className='loginrulestitle'>{DOMAINDISPLAY.name} encourages each of its Customers to actively participate in the management of their
gaming account and so offers a variety of responsible gambling features.
</p> 

<p className='loginrulestitle font-bold'>- Set Deposit Limits</p> 
<p className='loginrulestitle '>Take financial control of your gaming account with the ability to set your own preferred
deposit limits. <span className='font-bold'>Deposit limits</span> may be set for the following periods:</p> 

                        <ul className="rulesul">
                            <li>Daily (00:00 GMT. to 23:59 GMT.)</li>
                            <li>Weekly (Monday to Sunday)</li>
                            <li>Monthly (calendar month)</li>
                        </ul>
                        <p className='loginrulestitle '>At your request, deposit limits may be decreased, increased or removed entirely. An increase or
complete removal of deposit limits will take effect after a 24 hour cooling-off period, whilst a
decrease to deposit limits will be instantly applied.
</p>

<p className='loginrulestitle '>If you would like to set or adjust a deposit limit, please contact <span className='font-bold'>Customer Service</span> via email
<a href="mailto:support@1xbook.com">support@1xbook.com,</a> or live chat.</p>

<p  className='loginrulestitle font-bold'>- Stop Gambling – Exclusion</p>
<p  className='loginrulestitle'>At {DOMAINDISPLAY.name} we understand that a Customer’s personal / financial circumstances may change and
that there will be times when it makes sense to take a short break from gambling. In that case,
you can request to be excluded from gambling for definite periods of up to 30 days as per the
below list.</p>
<p  className='loginrulestitle'>If, however, at any stage, you become concerned about your gambling behaviour, or reach the
point where you feel you can no longer gamble safely even after having made use of definite
periods of exclusion, you need to stop and we can help by excluding you from future participation
at {DOMAINDISPLAY.name}, and all other brands managed by {DOMAINDISPLAY.name}. In that case, your exclusion would be for an
indefinite period.</p>

<p className='loginrulestitle'>The following Self-Exclusion options are available:</p>

                    <ul className="rulesul">
                            <li>24 hours</li>
                            <li>48 hours</li>
                            <li>72 hours</li>
                            <li>7 days</li>
                            <li>14 days</li>
                            <li>30 days</li>
                            <li>Indefinite</li>
                        </ul>
                        <p className='loginrulestitle '>Upon receipt of your <span className='font-bold'>Exclusion</span> request, {DOMAINDISPLAY.name} will take the necessary measures to</p>

                         <ul className="rulesul">
                                <li>block your access to {DOMAINDISPLAY.name} and all brands managed by {DOMAINDISPLAY.name};</li>
                            </ul>
            <p className='loginrulestitle '>{DOMAINDISPLAY.name} reserves the right to block a customer’s access to gambling indefinitely, should it believe
the individual to have a gambling problem.</p>
<p className='loginrulestitle '>As a further preventative measure, {DOMAINDISPLAY.name} recommends you consider applying the same
Exclusion safeguard at other gambling operators with whom you hold accounts.
</p>
<p className='loginrulestitle '>If you need to stop gambling, please contact <span className='font-bold'>Customer Service</span> via email <a href="mailto:support@1xbook.com">support@1xbook.com,</a>
or live chat.</p>

<p className='loginrulestitle font-bold'>Activity Statement</p>
<p className='loginrulestitle'>Information relating to each of your gaming sessions at {DOMAINDISPLAY.name} can be viewed for up to 6 months.
The information includes the start date and time of your gaming session, plus its duration.</p>
<p className='loginrulestitle'>Further information regarding your activity at {DOMAINDISPLAY.name} can also be viewed for a period of at least 6
months. The information includes details about your account balance, gambling history (including
bet amounts, winnings and losses), deposits, withdrawals and other related transactions.</p>

<p className='loginrulestitle font-bold'>Parental control</p>
<p>Do you share a computer with children? Always remember to keep your account information and
passwords secret. There is free software you can download that will help protect your children
from online gambling, two well recognised options include <a href="https://www.netnanny.com/">Net Nanny</a> and <a href="https://www.cybersitter.com/">CYBERsitter</a>. Our
customer support team is always happy to answer any questions you may have about safety and
the use of our site</p>
                <ul className="rulesul">
                                <li>Ensuring our Websites function correctly and identifying any technical issues;</li>
                            </ul>

                            <p className='loginrulestitle '>As we want to give our customers the ultimate {DOMAINDISPLAY.name} experience, we may also use your
personal data that we collect using cookies and other similar technologies (“cookies”) to protect
our Website, offer you a personalised experience with us, tailor our marketing services and
improve our Website and the services you request through login, including banking. For more
information about the cookies we use and how to manage your cookie preferences please see
our <span className='font-bold'>Cookie Policy.</span>
</p>
                <ul className="rulesul">
                                <li>Ensuring you <span className='font-bold'>gamble responsibly</span></li>
                            </ul>

                            <p className='loginrulestitle '>{DOMAINDISPLAY.name} is committed to ensuring that you gamble responsibly. So, to abide by legal obligations
we will process your data to provide you with a safe environment to gamble, as well as to monitor
you for potential at-risk behaviour
</p>
                <ul className="rulesul">
                                <li>Identifying and verifying customers;</li>
                            </ul>

                            <p className='loginrulestitle '>This includes the identification and verification of individuals under anti-money laundering
legislation, ensuring customers are over 18 and to comply with responsible gambling rules and
initiatives. To verify your age and the details that you registered your account with, we may
disclose such information to approved third parties with many safeguards in place. This is
required to meet our legal obligations.

</p>
                <ul className="rulesul">
                                <li>Legal and regulatory obligations;</li>
                            </ul>
                            <p className='loginrulestitle '>We are required to process and retain your personal data including but not limited to your name,
account number, date of birth and location to prevent fraudulent activity, to detect and/or
investigate crimes, and to ensure responsible gambling. Additionally, we may also process your
personal data to meet our internal and external reporting requirements. This is required to meet
our legal obligations</p>

<p className='loginrulestitle '>Depending on your marketing preferences, we will use your personal data to send you
information by the contact methods you authorise us to use about our brands, products,
competitions, prizes and offers for the purpose of marketing {DOMAINDISPLAY.name}'s Services to you.
</p>

<p className='loginrulestitle '>You can choose not to receive marketing/promotional material at any time by managing your
marketing preferences via My Account. We also provide you with the opportunity to opt out by
reply in every marketing message we send.</p>

<p className='loginrulestitle '>If you have opted out of receiving marketing communications from us, we will take all reasonable
steps to ensure you no longer receive promotional material about {DOMAINDISPLAY.name}. We may however still
send you transactional emails, relating to the maintenance of, and changes to, your account.</p>

<p className='loginrulestitle '>The information we send you about bonuses, promotions and markets is based on our legitimate
interest.</p>

    <ul className="rulesul">
        <li>Prevention of crime;</li>
    </ul>

    <p className='loginrulestitle '>{DOMAINDISPLAY.name} has various policies and procedures designed to detect and prevent criminal activity. This
includes fraud detection and our Anti-Money Laundering programme. We carry out this
processing to comply with our legal obligations.</p>

    <ul className="rulesul">
        <li>Processing your online financial and wagering transactions;</li>
    </ul>

    <p className='loginrulestitle '>We need to use your personal data such as your account details, payment type(s), deposit
method(s) and wager history to allow you to deposit and withdraw, and for our regulatory
reporting. This is to comply with our Terms and Conditions and legal obligations.</p>

    <ul className="rulesul">
        <li>Profiling and your preferences;</li>
    </ul>

    <p className='loginrulestitle '>{DOMAINDISPLAY.name} will create new personal data about you by processing your data including but not limited
to your betting and gameplay behaviour, interests, location and age to develop new features,
functionality, products and services that are tailored to you. This will help us to ensure that:
</p>

    <ul className="rulesul">
        <li>The technical help you may need is in line with the device that you use, and</li>
        <li>The promotions you receive are in line with your preferences, and</li>
        <li>The customer support you receive is in line with your jurisdiction.</li>
    </ul>

    <p className='loginrulestitle '>Additionally, {DOMAINDISPLAY.name} researches your preferences to develop new features, functionality, products
and services. This is in our legitimate interests. Additionally, this profiling is in our legal interests,
as profiling of your personal data is for reasons such as meeting our legal requirements with
regards to anti-money laundering, age verification, prevention of fraud, sports integrity and
responsible gambling.

</p>

    <ul className="rulesul">
        <li>Risk management;</li>
    </ul>

    <p className='loginrulestitle '>We review customer profile and betting data for the purposes of enforcing our terms and
conditions managing our financial liabilities and risk on events and markets. For more information
please see section 7 of the General Terms and Conditions. This is both to comply with our
legitimate interest and legal obligations</p>
<p className='loginrulestitle'>Certain trusted third party companies provide services essential to our ability to offer our
gambling products to you, for example those that supply the software and games for our
Websites, banking and payment services, identity verification, fraud prevention and risk
management. We may be required to share some of your information with these companies,
some of which may be based outside the European Economic Area (EEA), to be able to offer our
Services to you. In these instances, we ensure that the third party has appropriate security and
privacy arrangements in place, so that your data is protected.h</p>
<p className='loginrulestitle '>{DOMAINDISPLAY.name} may also be required to disclose your information to government authorities, such as the
police or our regulators, to comply with our legal obligations. Personal information may also be
shared with regulators, agencies or relevant sports bodies where there are suspicions of
involvement in match-fixing or breach of sports regulations. We will also disclose information as
required to enforce our terms of use as stated in the <span className='font-bold'>Terms and Conditions</span>.</p>
<p className='loginrulestitle'>In the event of the sale of our business, or other business event, which results in us having to
transfer your personal data to a third party, you will be notified via email, or notice posted on our
website, to explain the identity of the new data controller and your options regarding your
personal data.
</p>
<p className='loginrulestitle'>Our site may contain links to and from the Websites of third party organisations. Please note that
these Websites may have their own privacy policies and that we do not accept any responsibility
whatsoever for these policies. Please check these policies carefully before you submit any
personal data
</p>
<p className='loginrulestitle font-bold'>How we store your personal data</p>
<p className='loginrulestitle'>{DOMAINDISPLAY.name} is incorporated in Malta and your data is stored within the European Economic Area
(“EEA”) on our servers. But where we work with third parties, the data we collect from you may be
transferred to, and stored at, a destination outside the EEA. It may also be processed by staff
operating outside the EEA who work for us or for one of our suppliers. Such staff may be
engaged in, among other things, customer services, the processing of your payment details and
risk/fraud management.</p>
<p className='loginrulestitle'>We ensure there are appropriate contractual controls over any third party that helps us process
your data, ensuring that your rights are upheld and your data is secure.
</p>
<p className='loginrulestitle'>We store your data for as long as you are an active customer with us. Once you are no longer our
customer, we will hold your personal data on our systems for as long as is necessary to comply
with our legal obligations in your jurisdiction, such those imposed by tax, gambling and AML laws.
</p>
<p className='loginrulestitle font-bold'>Changes to this policy</p>
<p className='loginrulestitle'>We reserve the right to change this Privacy Policy at any time, so please re-visit this page
frequently. We will provide notice of substantial changes of this Privacy Policy and will send you a
notice or an email regarding such changes. Otherwise, all other changes to this Privacy Policy are
effective as of the stated “Last updated” date, and your continued use of the Services after the
Last Revised date will constitute acceptance of, and agreement to be bound by, those changes</p>

                                   </div>
                    </div>
                </div>
                
            </>
        )
    }
}
